import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { ActionableInsights, ActionableInsightsParams } from "app/pages/activation/types/api";

export const ACTIONABLE_INSIGHTS_KEY = "actionable-insights";

export const useActionableInsightsQuery = (params: ActionableInsightsParams, enabled = true) => {
    const { activationId, mainDomain, country, competitors } = params;

    return useQuery<ActionableInsights>({
        queryKey: [ACTIONABLE_INSIGHTS_KEY, activationId, mainDomain, country, competitors],
        queryFn: () => {
            const api = createActivationApi();

            return api.homeWithData.getActionableInsights(params);
        },
        enabled: !!activationId && !!mainDomain && !!country && !!competitors?.length && !!enabled,
        refetchOnMount: true,
    });
};
